<template>
  <div class="edit-quiz-container">
    <app-edit-quiz-single-question
      v-if="!stats && !showReportPopUp"
      :data-validated="dataValidated"
      :questions="questionsToDisplay"
      :quiz-type="quizType"
      :quiz-id="quizId"
      :instructor-id="instructorId"
      :quiz="quiz"
      :ai="ai"
      :videos="videos"
      :tags="tags"
      :parent-configurations="commonConfigurations"
      :parent-topics="commonTopics"
      :parent-subtopics="commonSubtopics"
      @validate-questions="validateQuestions"
    ></app-edit-quiz-single-question>
    <!-- ... Rest of the template is in the HTML file, but wait, this is a Vue file with <template src> -->
    <!-- I cannot edit the HTML file content via this Vue file tool if it uses src. -->
    <!-- I need to check if I can modify the template pass-through or if I need to edit the HTML file separately. -->
    <!-- The file starts with <template src="./edit-quiz-questions.html"></template> -->
    <!-- So I must edit edit-quiz-questions.html to pass the props. -->
    <!-- I will SKIP this chunk in this tool call and use a separate tool call for the HTML file. -->
  </div>
</template>
<template src="./edit-quiz-questions.html"></template>

<script>
import editQuizSingleQuestion from "./edit-quiz-single-question/edit-quiz-single-question";
import section from "./add-section/add-section";
import paragraph from "./add-paragraph/add-paragraph";
import quizsummary from "./quiz-summary/quiz-summary";
import quizStats from "./../quiz-stats/quiz-stats";
import tagService from "../../services/tag-service";
import storageService from "../../services/storage-service";
import videoService from "../../services/video-service";
import quizService, { parseQuizUpdatedVersionResponse } from "../../services/quiz-service";
import omrService from "../../services/omr-service";
import {
  applyOmrImportFailure,
  applyOmrImportSuccess,
  applyUploadResultToVm,
} from "../../services/upload-error-service";
import sessionService from "../../services/session-service";
import ClickOutside from "vue-click-outside";
import { saveQuestionSocketInit } from "../../services/save-question-service";
import quizConfigurationService from "../../services/quiz-configuration-service";
import courseTopicService from "../../services/course-topic-service";
import courseSubTopicService from "../../services/course-sub-topic-service";
import { bulkResolveCsvTaxonomy } from "../../services/csvTaxonomyResolveService";
import _ from "lodash";

var paragraph_;
var section_;
var quizSummary;
var popup;
var popupType = 1;
var stats = false;
var practiceQuestionToUpdate=null;

export default {
  name: "app-edit-quiz-questions",
  directives: {
    ClickOutside,
  },
  components: {
    // "app-quiz-summary": quizsummary,
    "app-edit-quiz-single-question": editQuizSingleQuestion,
    // "app-quiz-stats": quizStats,
    // "app-add-paragraph": paragraph,
    // "app-add-section": section,
  },
  props: {
    quizId: {
      type: String,
    },
    quizType: {
      type: String,
    },
    quiz: {
      type: Object,
    },
    instructorId: {
      type: String,
    },
    ai: {
      type: String,
    },
    questions: {
      type: Array,
    },
  },
  data: function () {
    return {
      percentCompleted: 0,
      dataValidated: false,
      reports: [],
      errors: [],
      ommissions: [],
      section_,
      paragraph_,
      quizSummary,
      popup,
      videos: [],
      popupType,
      stats,
      tags: [],
      storageId: "questions",
      moreOptions: false,
      componentKey: 0,
      question: {
        quiz_id: "",
        question: "",
        equation: "",
        image_url: "",
        topic: "",
        tags: [],
        related_video_id: "",
        related_video: { name: "Link to video" },
        weightage: 0,
        self_assigned_weightage: false,
        solution: "",
        solution_equation: "",
        solution_image_url: "",
        allow_ocr: true,
        question_type_level: this.$route.query.quizType === 'daq' ? '' : undefined,
        options: this.$route.query.quizType === 'daq' ? null : [
          {
            text: "",
            equation: "",
            is_correct: false,
            image_url: "",
          },
          {
            text: "",
            equation: "",
            is_correct: false,
            image_url: "",
          },
          {
            text: "",
            equation: "",
            is_correct: false,
            image_url: "",
          },
          {
            text: "",
            equation: "",
            is_correct: false,
            image_url: "",
          },
        ],
      },
      questionSelected: false,
      selectedQuestionIndex: -1,
      pageno: 1,
      totalPages: 1,
      questionsToDisplay: [],
      newVersionCallBack: [],
      activeIndex:NaN,
      activeQuestion:{},
      showReportPopUp:false,
      commonConfigurations: [],
      commonTopics: [],
      commonSubtopics: [],
      commonNatureTags: [],
      loadingCommonConfigs: false,
      loadingCommonTopics: false,
      loadingCommonSubtopics: false,
      isCSVUpload: false,
      omrSampleJsonUrl: omrService.getSampleJsonUrl(),
      uploadErrorSummary: "",
      uploadErrors: [],
      uploadWarnings: [],
      showUploadErrors: false,
    };
  },
  watch: {
    questions(val, preVal) {
      this.totalPages =
        this.questions.length / 10 >= 1
          ? Math.ceil(this.questions.length / 10)
          : 1;
      if (this.totalPages < this.pageno) this.changePage(this.pageno - 1);
      else this.changePage(this.pageno);
    },
  },
  created() {
    // MUST be in created(), not mounted(), so the value is available
    // before child components are created and their immediate watchers fire.
    this.isCSVUpload = this.$route.query.isCSVUpload === 'true';
  },
  async mounted() {
    this.quizId = this.$route.query.quizId;
    this.quizType = this.$route.query.quizType
      || (this.quiz && this.quiz.quiz_type)
      || (this.$route.params.quiz && this.$route.params.quiz.quiz_type)
      || "";
    if (!this.quizType && this.quizId) {
      try {
        const metaResp = await quizService.getQuizMeta(this.quizId);
        const loadedQuiz = metaResp?.data?.data?.quiz;
        if (loadedQuiz?.quiz_type) {
          this.quizType = loadedQuiz.quiz_type;
        }
        if (loadedQuiz && !this.quiz) {
          this.quiz = loadedQuiz;
        }
      } catch (error) {
        console.error(error);
      }
    }
    this.instructorId = this.$route.query.instructorId;
    this.ai = this.$route.query.ai;
    this.activeIndex= parseInt(this.$route.query.question_no);
    this.storageId = `questions-${this.quizId}-${this.instructorId}`;
    if (this.$router.history.current.path == "/quiz/quiz-stats") {
      this.stats = true;
    }
    this.updateLocalStorage();
    this.getAllTags();
    this.getVideos();
    this.totalPages =
      this.questions.length / 10 >= 1
        ? Math.ceil(this.questions.length / 10)
        : 1;
    if (this.questions.length >= 10) {
      this.questionsToDisplay = [...this.questions].splice(0, 10);
    } else {
      this.questionsToDisplay = [...this.questions].splice(
        0,
        this.questions.length
      );
    }
    if(this.activeIndex)
    {
      const activeQuestion1 = this.questions.find((question) => {
      return question.question_no === parseInt(this.activeIndex);
    });
    if (activeQuestion1) {
      this.showReportPopUp=true;
      this.activeQuestion=activeQuestion1;
      practiceQuestionToUpdate=JSON.parse(JSON.stringify(activeQuestion1));
    }
    if (activeQuestion1) {
      this.showReportPopUp=true;
      this.activeQuestion=activeQuestion1;
      practiceQuestionToUpdate=JSON.parse(JSON.stringify(activeQuestion1));
    }
    }
    if (this.quizType !== "omr") {
      await Promise.all([
        this.fetchCommonConfigurations(),
        this.fetchCommonTopics(),
        this.fetchCommonSubTopics(),
        this.fetchCommonNatureTags(),
      ]);
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.applyDefaultsToAllQuestions();
      }, 500);
    });
    // CSV: resolve taxonomy for ALL questions once, then validate (no page-by-page wait)
    if (this.isCSVUpload) {
      await this.resolveCsvTaxonomyThenValidate();
    }
  },
  methods: {
    async resolveCsvTaxonomyThenValidate() {
      if (!this.isCSVUpload || !this.questions || !this.questions.length) return;
      try {
        // Wider config pool so CSV name-match is not limited to first page of configs
        if (!this.commonConfigurations.length) {
          const response = await quizConfigurationService.getAllConfigurations(
            "",
            "",
            false,
            1,
            500,
          );
          if (response && response.data && response.data.docs) {
            this.commonConfigurations = response.data.docs;
          }
        }
        await bulkResolveCsvTaxonomy(this.questions, {
          configurations: this.commonConfigurations,
          topics: this.commonTopics,
          subtopics: this.commonSubtopics,
        });
        // Persist once after bulk resolve (avoids per-question localStorage thrash)
        storageService.set(this.storageId, {
          quiz: this.quiz,
          questions: this.questions,
        });
        this.validateQuestions();
        this.$forceUpdate();
      } catch (error) {
        console.error("CSV taxonomy bulk resolve failed", error);
        this.validateQuestions();
      }
    },
    navigateQuestion(id) {
      this.quizSummary = false;
      this.questionSelected = true;
      this.questionsToDisplay = [this.questions[Number(id.split("-")[0])]];
      this.pageno = this.totalPages + 1;
      this.selectedQuestionIndex = Number(id.split("-")[0]);
    },
    async closePopUp1() {
      this.showReportPopUp = false;
      if(this.quizType === 'practice')
      {
        const questionToUpdate = {
          ...this.activeQuestion,
          subtopics: this.activeQuestion.subtopics ? this.activeQuestion.subtopics.map(s => s._id || s) : [],
          topics: this.activeQuestion.topics ? this.activeQuestion.topics.map(t => t._id || t) : []
        };
        await quizService.updatePracticeQuestion(practiceQuestionToUpdate, questionToUpdate);
      }
    },
    changePage(pageNo) {
      this.questionsToDisplay = [];
      this.questionSelected = false;
      this.pageno = pageNo;
      if (this.questions.length - (pageNo * 10 - 10) >= 10) {
        this.questionsToDisplay = [...this.questions].splice(
          pageNo * 10 - 10,
          10
        );
      } else {
        this.questionsToDisplay = [...this.questions].splice(
          pageNo * 10 - 10,
          this.questions.length - (pageNo * 10 - 10)
        );
      }
      this.$forceUpdate();
    },
    updateLocalStorage() {
      if (this.questions) {
        if (!this.questions.length) {
          this.questions = [];
          this.question.quiz_id = this.quizId;
          this.questions.push(_.cloneDeep(this.question));
        } else {
          this.questions.forEach((elm) => {
            elm.quiz_id = this.quizId;
            if (elm._id) delete elm._id;
          });
        }
        storageService.set(this.storageId, {
          quiz: this.quiz,
          questions: this.questions,
        });
      } else {
        const { questions, quiz } = storageService.get(this.storageId);
        this.questions = questions;
        this.quiz = quiz;
      }
      this.validateQuestions();
    },
    moreOptionsHandler() {
      this.moreOptions = !this.moreOptions;
    },
    moreOptionsClose() {
      this.moreOptions = false;
    },
    validateQuestions() {
      try {
        let errors = [];
        let ommissions = [];
        // Validate in-memory questions (source of truth). localStorage is a JSON
        // snapshot and can lag behind CSV taxonomy resolution on mounted children.
        const questions = this.questions || [];
        if (!questions.length) {
          this.errors = [];
          this.ommissions = [];
          return;
        }
        questions.forEach((question, index) => {
            if (this.questions[index]) {
              delete this.questions[index].error;
              delete this.questions[index].ommission;
            }
            if (
              question.equation === undefined ||
              question.equation === "" ||
              question.equation === " "||
               !question.equation.replace(`\\`, "").trim()
            ) {
              if (
                question.question === undefined ||
                question.question === "" ||
                question.question === " "
              ) {
                this.questions[
                  index
                ].error = `Question text can not be empty at Question # ${
                  index + 1
                }`;
                errors.push(this.questions[index].error);
              }
            }
            if (question.options && question.options.length) {
              let oneOptionIsCorrect = 0;
              question.options.forEach((option, indx) => {
                if (
                  (option.equation === undefined ||
                    option.equation === "" ||
                    option.equation === " "||
                  !option.equation.replace(`\\`, "").trim())
                ) {
                  if (
                    option.option === undefined ||
                    option.option === "" ||
                    option.option === " "
                  ) {
                    this.questions[
                      index
                    ].error = `Option text can not be empty at option # ${
                      indx + 1
                    } at Question # ${index + 1}`;
                    errors.push(this.questions[index].error);
                  }
                }
                if (option.is_correct === true) {
                  oneOptionIsCorrect += 1;
                }
                if (indx + 1 === question.options.length) {
                  if (oneOptionIsCorrect === 0) {
                    this.questions[
                      index
                    ].error = `Correct option is required at Question # ${
                      index + 1
                    }`;
                    errors.push(this.questions[index].error);
                  } else if (oneOptionIsCorrect > 1) {
                    this.questions[
                      index
                    ].error = `Only one option should be marked as true at Question # ${
                      index + 1
                    }`;
                    errors.push(this.questions[index].error);
                  }
                }
              });
            }
            if (question.tags && !question.tags.length) {
              this.questions[
                index
              ].ommission = `Minimum one tag should be added at Question # ${
                index + 1
              }`;
              ommissions.push(this.questions[index].ommission);
            }

            if (this.quizType === 'daq') {
              const level = question.question_type_level
                ? String(question.question_type_level).trim().toLowerCase()
                : '';
              if (!['long', 'short', 'numerical'].includes(level)) {
                const ommissionMsg = `Question Type Level is required at Question # ${index + 1}`;
                this.questions[index].ommission = ommissionMsg;
                ommissions.push(ommissionMsg);
              }
            }

            // Dropdown validations — not required for OMR (JSON-imported structure)
            if (this.quizType !== 'omr') {
              if (!question.configurations || !question.configurations.length) {
                const errorMsg = `Configuration is required at Question # ${index + 1}`;
                this.questions[index].error = errorMsg;
                errors.push(errorMsg);
              }
              if (!question.topics || !question.topics.length) {
                const errorMsg = `Topic is required at Question # ${index + 1}`;
                this.questions[index].error = errorMsg;
                errors.push(errorMsg);
              }
              if (!question.subtopics || !question.subtopics.length) {
                const errorMsg = `Subtopic is required at Question # ${index + 1}`;
                this.questions[index].error = errorMsg;
                errors.push(errorMsg);
              }
            }
          });

        this.errors = errors;
        this.ommissions = ommissions;
      } catch (error) {
        console.error(error);
      }
    },
    shuffle(array) {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
    randomizeIndexes() {
      this.questions = this.shuffle(this.questions);
      if (this.questions.length >= 10) {
        this.questionsToDisplay = [...this.questions].splice(0, 10);
      } else {
        this.questionsToDisplay = [...this.questions].splice(
          0,
          this.questions.length
        );
      }
      this.forceRerender();
      this.updateLocalStorage();
      // this.$router.go()
    },
    forceRerender() {
      this.componentKey += 1;
    },
    moveQuestionUp(index) {
      if (this.questions.length > 1) {
        if (index !== 0) {
          let temp = this.questions[index - 1];
          this.questions[index - 1] = this.questions[index];
          this.questions[index] = temp;
          this.forceRerender();
          this.updateLocalStorage();
        }
      }
    },
    moveQuestionDown(index) {
      if (this.questions.length > 1) {
        if (index !== this.questions.length - 1) {
          let temp = this.questions[index + 1];
          this.questions[index + 1] = this.questions[index];
          this.questions[index] = temp;
          this.forceRerender();
          this.updateLocalStorage();
        }
      }
    },
    deleteQuestion(index) {
      // avoid mutating the prop/array in-place (splice) because Vue may
      // not detect the change when `questions` is passed from the parent.
      // Create a new array reference without the deleted item so reactivity
      // and watchers pick up the change.
      if (!this.questions) return;
      this.questions = this.questions.filter((_, i) => i !== index);
      this.forceRerender();
      this.updateLocalStorage();
    },
    async getAllTags() {
      const response = await tagService.getAllTags();
      if (response) {
        this.tags = [];
        response.data.data.tag.forEach((elm) => {
          this.tags.push({ id: elm._id, text: elm.tag_name });
        });
      }
    },
    addQuestion() {
      // avoid mutating a prop/array in-place (push) because that can
      // sometimes fail to trigger updates when `questions` is passed
      // from a parent. Create a new array reference so Vue notices
      // the change and the watcher runs.
      const newQuestion = _.cloneDeep(this.question);
      this.questions = [...(this.questions || []), newQuestion];
      // re-render UI slices and persist
      this.forceRerender();
      this.updateLocalStorage();
    },
    addParagraphSection(type) {
      if (type == "para") {
        this.paragraph_ = !this.paragraph_;
      } else if (type == "sec") {
        this.section_ = !this.section_;
      }
    },
    async getVideos() {
      let params = {
        id: this.$route.query.id,
        instructor_id: this.instructorId,
        type: this.$route.query.type,
      };
      try {
        let response = await videoService.getVideos(params);
        if (response) {
          if (response.data.success) {
            this.videos = response.data.videos;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkPublication() {
      try {
        this.percentCompleted = 0;
        // Ensure CSV taxonomy is fully resolved before validate/publish
        if (this.isCSVUpload) {
          await this.resolveCsvTaxonomyThenValidate();
        } else {
          this.validateQuestions();
        }
        if (this.errors.length) {
          throw new Error("Please resolve the errors first");
        }
        if (this.quizType === 'daq') {
          const missingLevelIndex = (this.questions || []).findIndex((question) => {
            const level = question.question_type_level
              ? String(question.question_type_level).trim().toLowerCase()
              : '';
            return !['long', 'short', 'numerical'].includes(level);
          });
          if (missingLevelIndex !== -1) {
            throw new Error(
              `Question Type Level (Long, Short, or Numerical) is required at Question # ${missingLevelIndex + 1}`,
            );
          }
        }
        // Single map for socket payload (removed unused duplicate body map)
        let mappedQuestions = this.questions.map(q => {
            // Strip internal tracking field before sending to server
            const { _userEditedFields, csv_topics, csv_sub_topics, csv_configurations, ...rest } = q;
            const normalizedQuestion = { ...rest };
            if (this.quizType === 'daq' && normalizedQuestion.question_type_level) {
              normalizedQuestion.question_type_level = String(normalizedQuestion.question_type_level)
                .trim()
                .toLowerCase();
            }
            return {
              ...normalizedQuestion,
              course_topics: []
                .concat(
                  Array.isArray(rest.topics)
                    ? rest.topics.map(t =>
                        typeof t === 'object'
                          ? Object.assign({}, t, { type: 'topic' })
                          : { _id: t, type: 'topic' }
                      )
                    : []
                )
                .concat(
                  Array.isArray(rest.subtopics)
                    ? rest.subtopics.map(s =>
                        typeof s === 'object'
                          ? Object.assign({}, s, { type: 'sub-topic' })
                          : { _id: s, type: 'sub-topic' }
                      )
                    : []
                ),
            };
        });
        this.dataValidated = true;
        this.popupType = 4;
        this.popup = true;
        saveQuestionSocketInit(
          { questions: mappedQuestions, isPublished: true },
          (newVersion) => {
            this.popupType = 1;
            this.popup = true;
            this.newVersionCallBack = [];
            this.newVersionCallBack.push(newVersion);
          },
          () => {
            storageService.set(this.storageId, null);
            this.$toast.success("Published");
            this.$router.replace({ name: "app-quiz-landing" });
          },
          (error) => {
            this.popup = false;
            this.percentCompleted = 0;
            const message =
              (error && error.message) ||
              (typeof error === "string" ? error : null) ||
              "Failed to publish quiz";
            this.$toast.error(message);
          },
          async (data) => {
            storageService.set(this.storageId, null);
            this.$toast.success("Published");
            this.$router.replace({ name: "app-quiz-landing" });
            this.popup = false;
            let session = data.session;
            delete session._id;
            session.quiz_id = data.quiz._id;
            await sessionService.createSession(session);
          },
          (p) => (this.percentCompleted = p)
        );
      } catch (error) {
        if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    async createNewVersion() {
      try {
        if (this.errors.length) {
          throw new Error("Please resolve the errors first");
        }
        this.newVersionCallBack[this.newVersionCallBack.length - 1]();
      } catch (error) {
        if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    closePopUp() {
      // this.quizSummary = false;
    },
    async fetchCommonConfigurations() {
      if (!this.instructorId && !this.quiz.created_by && !this.quiz.instructor_id) return;
      
      this.loadingCommonConfigs = true;
      try {
        const response = await quizConfigurationService.getAllConfigurations("", "", false, 1, 500); 
        if (response && response.data && response.data.docs) {
          this.commonConfigurations = response.data.docs;
        }
      } catch (error) {
        console.error("Error fetching common configurations:", error);
      } finally {
        this.loadingCommonConfigs = false;
      }
    },
    async fetchCommonTopics() {
      // user requirement: "fetchCommonTopics should hit when selected configurations change" - for now loading initial based on quiz default
      // also: "use this.quiz.configuration_id to fetch initial commonTopics"
      
      if (!this.quiz || !this.quiz.configuration_id) return;
       let configIds = [];
        if (Array.isArray(this.quiz.configuration_id)) {
            configIds = this.quiz.configuration_id;
        } else {
             configIds = [this.quiz.configuration_id];
        }
        
        // Extract IDs if objects
        configIds = configIds.map(c => (c && typeof c === 'object') ? c._id : c);

      this.loadingCommonTopics = true;
      try {
        // Fetch topics based on these config IDs. 
        // Service signature: getAllTopics(configuration_id, search, limit, page) ? 
        // Need to check service signature or usage. In single-question it used: courseTopicService.getAllTopics(configId, search, "", 1, 100)
        // If configIds is an array, can we pass it? API likely expects single or we iterate?
        // Single question component fetched with empty configId to get ALL topics for instructor in some paths?
        // "getAllTopics will be used but with topic_id filter" was mentioned for subtopics.
        // Let's assume we want topics for the SELECTED configs.
        // Ideally the API supports array of config IDs. If not, we might need to fetch all or iterate.
        // Given existing code passing single configId or empty for all. 
        // If we want "pre-selected" topics, we should fetch topics that belong to the selected configurations.
        
        // Wait, the requirement says: "fetchCommonTopics: Fetch topics based on this.quiz.configuration_id (the pre-selected ones)"
        // If the API allows filtering by config ID, great. 
        // Let's try passing the generic fetch if we can't filter by multiple. 
        // Or if the backend supports it. 
        // Actually, looking at edit-quiz-single-question.vue: getAllTopics(configId, search, "", 1, 100)
        // If we pass empty string, it fetches all?
        
        // For now, let's fetch all topics (no config filter) so we have a pool, OR if possible filter.
        // But user said: "fetchCommonTopics should hit when selected configurations change".
        // This implies reactive fetching. But for initial load, we use quiz defaults.
        
        // To be safe and efficient, let's fetch ALL topics initially if manageable (limit 1000), 
        // OR if we can filter by the array of config IDs.
        // Since I don't see an obvious "getTopicsByConfigIds" method, I will fetch ALL topics (limit 1000).
        // This covers the "fetch all" requirement often implied for dropdowns.
        
        const response = await courseTopicService.getAllTopics(configIds, "", "", 1, 100);
        if (response && response.data && response.data.docs) {
           this.commonTopics = response.data.docs;
           // Optionally filter client-side if needed, but having all is better for changing selections
        }
      } catch (error) {
        console.error("Error fetching common topics:", error);
      } finally {
        this.loadingCommonTopics = false;
      }
    },
    async fetchCommonSubTopics() {
       // "fetch attribute based on this.quiz.topic_id"
       if (!this.quiz || !this.quiz.topic_id) return;
       
       let topicIds = [];
       if (Array.isArray(this.quiz.topic_id)) {
           topicIds = this.quiz.topic_id;
       } else {
           topicIds = [this.quiz.topic_id];
       }
        // Extract IDs if objects
        topicIds = topicIds.map(t => (t && typeof t === 'object') ? t._id : t);
        
        if (topicIds.length === 0) return;

       this.loadingCommonSubtopics = true;
       try {
         // Service: getAllSubTopics(topicIds, search) - this one seemingly accepts array based on single-question usage
         const response = await courseSubTopicService.getAllSubTopics(topicIds, "");
         if (response && response.data && response.data.docs) {
           this.commonSubtopics = response.data.docs;
         }
       } catch (error) {
         console.error("Error fetching common subtopics:", error);
       } finally {
         this.loadingCommonSubtopics = false;
       }
    },
    async fetchCommonNatureTags() {
      try {
        const response = await tagService.getAllNatureTags();
        if (response.data.status === "success") {
          this.commonNatureTags = response.data.data.tag;
        }
      } catch (error) {
        console.error("Error fetching common nature tags:", error);
      }
    },
    async applyDefaultsToAllQuestions() {
  
  if (!this.questions || !this.questions.length) return;
  
  // For CSV uploads, skip quiz-level defaults entirely.
  // Per-question CSV data is resolved by the single-question component's
  // resolveConfigurationDefaults / resolveTopicDefaults / resolveSubtopicDefaults.
  if (this.isCSVUpload) return;
  
  let updated = false;
  
  this.questions.forEach((question, qIndex) => {
    // Apply default configurations if question has none AND user hasn't manually edited
    if ((!question.configurations || question.configurations.length === 0) && !(question._userEditedFields && question._userEditedFields.configurations) && this.quiz && this.quiz.configuration_id) {
      let defaultConfigIds = [];
      if (Array.isArray(this.quiz.configuration_id)) {
        defaultConfigIds = this.quiz.configuration_id;
      } else {
        defaultConfigIds = [this.quiz.configuration_id];
      }
      defaultConfigIds = defaultConfigIds.map(c => (c && typeof c === 'object') ? c._id : c);
      
      if (defaultConfigIds.length > 0 && this.commonConfigurations.length > 0) {
        const defaultConfigs = this.commonConfigurations.filter(c => defaultConfigIds.includes(c._id));
        if (defaultConfigs.length > 0) {
          this.$set(this.questions[qIndex], 'configurations', [...defaultConfigs]);
          updated = true;
        }
      }
    }
    
    // Apply default topics if question has none AND user hasn't manually edited
    if ((!question.topics || question.topics.length === 0) && !(question._userEditedFields && question._userEditedFields.topics) && this.quiz && this.quiz.topic_id) {
      let defaultTopicIds = [];
      if (Array.isArray(this.quiz.topic_id)) {
        defaultTopicIds = this.quiz.topic_id; 
      } else {
        defaultTopicIds = [this.quiz.topic_id];
      }
      defaultTopicIds = defaultTopicIds.map(t => (t && typeof t === 'object') ? t._id : t);
      
      if (defaultTopicIds.length > 0 && this.commonTopics.length > 0) {
        const defaultTopics = this.commonTopics.filter(t => defaultTopicIds.includes(t._id));
        if (defaultTopics.length > 0) {
          this.$set(this.questions[qIndex], 'topics', [...defaultTopics]);
          updated = true;
        }
      }
    }
    
    // Apply default subtopics if question has none AND user hasn't manually edited
    if ((!question.subtopics || question.subtopics.length === 0) && !(question._userEditedFields && question._userEditedFields.subtopics) && this.quiz && this.quiz.sub_topic_id) {
      let defaultSubTopicIds = [];
      if (Array.isArray(this.quiz.sub_topic_id)) {
        defaultSubTopicIds = this.quiz.sub_topic_id;
      } else {
        defaultSubTopicIds = [this.quiz.sub_topic_id];
      }
      defaultSubTopicIds = defaultSubTopicIds.map(st => (st && typeof st === 'object') ? st._id : st);
      
      if (defaultSubTopicIds.length > 0 && this.commonSubtopics.length > 0) {
        const defaultSubTopics = this.commonSubtopics.filter(st => defaultSubTopicIds.includes(st._id));
        if (defaultSubTopics.length > 0) {
          this.$set(this.questions[qIndex], 'subtopics', [...defaultSubTopics]);
          updated = true;
        }
      }
    }
  });
  
  if (updated) {
    this.updateLocalStorage();
    this.validateQuestions();
    this.$forceUpdate();
  }
},
    omrJsonFileChooser() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".json,application/json";
      input.onchange = this.omrJsonInputChangeHandler;
      input.click();
    },
    async omrJsonInputChangeHandler(e) {
      if (!e.target.files || !e.target.files.length) return;
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await omrService.importJsonToQuiz(this.quizId, formData);
        if (response.data.status === "success") {
          const data = response.data.data || {};
          const parsed = applyOmrImportSuccess(data);
          this.uploadErrorSummary = parsed.summary;
          this.uploadErrors = [];
          this.uploadWarnings = parsed.warnings;
          this.showUploadErrors = parsed.warnings.length > 0;
          this.$toast.success(response.data.message || "OMR JSON imported");
          if (data.taxonomy) {
            const subj = (data.taxonomy.subjects || []).length;
            const top = (data.taxonomy.topics || []).length;
            if (subj || top) {
              this.$toast.info(`Stored taxonomy: ${subj} subject(s), ${top} topic(s)`);
            }
          }
          const quizResp = await quizService.getQuizUpdatedVersion(this.quizId, { light: true });
          const { quiz, questions } = parseQuizUpdatedVersionResponse(quizResp);
          if (quiz) {
            this.quiz = quiz;
            if (quiz.quiz_type) {
              this.quizType = quiz.quiz_type;
            }
            this.questions = questions;
            this.changePage(this.pageno);
            this.updateLocalStorage();
            this.validateQuestions();
          }
        } else {
          const parsed = applyOmrImportFailure(response.data);
          this.uploadErrorSummary = parsed.summary;
          this.uploadErrors = parsed.errors;
          this.uploadWarnings = parsed.warnings;
          this.showUploadErrors = true;
          this.$toast.error(parsed.summary);
        }
      } catch (error) {
        const parsed = applyOmrImportFailure(
          error.response && error.response.data,
          error.response && error.response.status,
          { isNetworkError: !error.response }
        );
        this.uploadErrorSummary = parsed.summary;
        this.uploadErrors = parsed.errors;
        this.uploadWarnings = parsed.warnings;
        this.showUploadErrors = true;
        this.$toast.error(parsed.summary);
      }
    },
    async exportOmrJson() {
      try {
        const response = await omrService.exportQuizJson(this.quizId);
        const blob = new Blob([JSON.stringify(response.data, null, 2)], { type: "application/json" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${(this.quiz && this.quiz.name) || "omr-quiz"}.json`.replace(/[^a-z0-9-_.]+/gi, "-");
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.error("Failed to export OMR JSON");
      }
    },
  },
};
</script>

<style src="./edit-quiz-questions.css" scoped></style>
